export default "__VITE_ASSET__87e53496__"